import { AccountType } from "./AccountType";
import { ServiceAddressDto, DefaultServiceAddressDto } from "./ServiceAddressDto";

export type CustomerDetailsDto = {
  accountType?: AccountType | null;
  accountNumber: string;
  accountName: string;
  accountPin: string;
  authorizedName: string;
  billingPhoneNumber: string;
  serviceAddress: ServiceAddressDto;
};

export const DefaultCustomerDetailsDto: CustomerDetailsDto = {
  accountType: null,
  accountNumber: "",
  accountName: "",
  accountPin: "",
  authorizedName: "",
  billingPhoneNumber: "",
  serviceAddress: DefaultServiceAddressDto
};